import styled from 'styled-components';

export const LyziIframeContainer = styled.div`
    .lyzi-wrapper {
        max-width: 500px;
        margin-top: 40px;
        text-align: center;

        p {
            font-size: 15px;
            margin-bottom: 40px;
            font-weight: bold;
        }

        .lyzi {
            margin: 0;

            .cryptos-icon {
                margin-bottom: 10px;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/iframes/lyzi/LyziIframeStyle.js